import { XIcon } from "lucide-react";
import React, { useState } from "react";

interface CustomErrorHandlingModalProps {
  errorType?: "validation" | "api" | "error";
  onClose: any;
  errorValue?: any;
  setIsErrorHandlingModalOpen?: any;
  errorHandlingModalData?: any;
  setErrorHandlingModalData?: any;
  handleAddBidderAnyway: any;
  setIsOverwrite: any;
}

export default function CustomErrorHandlingModal({
  errorType,
  onClose,
  setIsErrorHandlingModalOpen,
  errorHandlingModalData,
  setErrorHandlingModalData,
  handleAddBidderAnyway,
  setIsOverwrite,
}: CustomErrorHandlingModalProps) {
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <div className="bg-white shadow-2xl  w-full max-w-[300px] mobile:max-w-[380px] md:max-w-lg p-6 relative  max-h-[95vh] overflow-y-auto">
        <div className="w-full flex justify-between items-center  pb-3">
          <p className="font-openSans font-semibold text-web-body-lg leading-5 text-brand-bgBlack">
            {errorType === "validation"
              ? "Validation Error"
              : errorType === "api"
              ? "Error"
              : "Error"}
          </p>
          <button
            onClick={() => {
              setIsOverwrite(false);
              setIsErrorHandlingModalOpen({ open: false, type: "validation" });
              setErrorHandlingModalData(null);
            }}
            className="text-gray-500 bg-brand-bgLightGrey rounded-full p-1.5 hover:text-gray-700"
          >
            <XIcon className="h-6 w-6" />
          </button>
        </div>

        <div>
          <p className="font-openSans text-xs text-brand-textGrey">
            Please review the highlighted fields and correct the corresponding
            errors before proceeding.
          </p>
        </div>
        <div>
          {errorHandlingModalData?.map((error: any, index: number) => (
            <div key={index} className="mt-4">
              {errorType === "validation" && (
                <p className="font-openSans font-semibold text-sm text-brand-bgBlack">
                  {error.bidderLabel || "Bidder Data"}:
                </p>
              )}
              {errorType === "error" && (
                <p className="font-openSans font-semibold text-sm text-brand-bgBlack">
                  Error Data:
                </p>
              )}
              <ul className="list-disc list-inside">
                {Object.entries(error).map(([field, message]) => {
                  if (field !== "index" && field !== "bidderLabel" && message) {
                    return (
                      <li
                        key={field}
                        className="font-openSans text-xs text-brand-textGrey"
                      >
                        <span className="text-red-500 font-semibold capitalize">
                          {field.replace(/_/g, " ")}:{" "}
                        </span>
                        {message as string}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            </div>
          ))}
        </div>

        {(errorType === "validation" || errorType === "error") && (
          <div className="w-full flex justify-center mt-6">
            <button
              className={`bg-brand-textBlack text-white px-6 py-2 lg:w-[225px] rounded-lg hover:bg-brand-textBlack`}
              onClick={() => {
                setIsOverwrite(false);
                setIsErrorHandlingModalOpen({
                  open: false,
                  type: "validation",
                });
                setErrorHandlingModalData(null);
              }}
            >
              Close
            </button>
          </div>
        )}
        {errorType === "api" && (
          <div>
            <div className="w-full flex gap-2 justify-center mt-6">
              <button
                disabled={loading}
                className="bg-brand-textBlack text-white px-6 py-2 lg:w-[225px] rounded-lg hover:bg-brand-textBlack"
                onClick={() => {
                  setIsOverwrite(false);
                  setIsErrorHandlingModalOpen({
                    open: false,
                    type: "validation",
                  });
                  setErrorHandlingModalData(null);
                }}
              >
                Close
              </button>
              <button
                disabled={!isChecked || loading}
                className={`px-6 py-2 lg:w-[225px] rounded-lg text-white ${
                  isChecked
                    ? "bg-brand-textBlack hover:bg-brand-textBlack"
                    : "bg-brand-textLightGrey cursor-not-allowed"
                }`}
                onClick={async () => {
                  setLoading(true);
                  await handleAddBidderAnyway();
                  setIsErrorHandlingModalOpen({
                    open: false,
                    type: "validation",
                  });
                  setErrorHandlingModalData(null);
                  setIsOverwrite(false);
                  setLoading(false);
                }}
              >
                Add Anyway
              </button>
            </div>
            <div className="text-xs text-brand-textGrey flex flex-col gap-2 mt-4">
              <p className="font-bold">Notice:</p>
              <p>
                1. If this bidder already exists, review the details. Add the
                record only if the intention is to validate by email. For this
                auction event, the user will be required to log in using email
                only to access the auction floor.
              </p>
              <p>
                2. If this bidder already exists, adding them again is not
                recommended. Instead, try reaching out to the user and confirm
                if their existing system details can be used to avoid any data
                mismatch.
              </p>
              <p>
                3. If this bidder already exists, choosing Add Anyway will still
                validate the email for this auction event.
              </p>

              <label className="flex items-center gap-2 mt-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => {
                    setIsChecked(e.target.checked);
                    setIsOverwrite(e.target.checked);
                  }}
                  className="mt-1 h-4 w-4 text-brand-orange border-brand-orange rounded"
                />
                <span className="text-brand-textBlack">
                  I understand the above notice
                </span>
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
